import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

import "bootstrap/dist/css/bootstrap.min.css";
// Import our css after bootstrap - we may use some bootstrap stuff, but we want ours to over-ride
import "./index.scss";

// Suppress ResizeObserver loop error (benign error from video player) so it does not trigger the React error overlay.
const isResizeObserverError = (message = "") => (
  message.includes("ResizeObserver loop limit exceeded") ||
  message.includes("ResizeObserver loop completed with undelivered notifications")
);

const ignoredWarningSnippets = [
  "Received `false` for a non-boolean attribute `visible`",
  "React does not recognize the `aspectRatio` prop on a DOM element",
  "Support for defaultProps will be removed from function components"
];

const isIgnorableWarning = (message = "") => {
  if (!message) return false;
  if (isResizeObserverError(message)) return true;
  return ignoredWarningSnippets.some(snippet => message.includes(snippet));
};

// Capture phase listener to stop propagation early
window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

// window.onerror as a fallback (must return true to prevent the overlay)
window.onerror = (message) => {
  if (isResizeObserverError(String(message))) {
    return true;
  }
};

// Also guard unhandledrejection just in case
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || event.reason?.toString?.() || "";
  if (isIgnorableWarning(msg)) {
    event.preventDefault();
    return true;
  }
});

// Filter console.error so the overlay doesn't render
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args.map(a => (a && a.toString ? a.toString() : String(a))).join(' ');
  if (isIgnorableWarning(message)) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Filter console.warn for the same noisy warnings
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  const message = args.map(a => (a && a.toString ? a.toString() : String(a))).join(' ');
  if (isIgnorableWarning(message)) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

// As a last resort, silence the React error overlay for these ignorable cases
const overlay = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__;
if (overlay) {
  const noop = () => {};
  overlay.handleRuntimeError = noop;
  overlay.showRuntimeError = noop;
  overlay.clearRuntimeErrors = noop;
  overlay.dismissRuntimeErrors = noop;
}

// Hide any dev-server overlays as a final guard
const hideOverlayCss = document.createElement('style');
hideOverlayCss.innerHTML = `
  #webpack-dev-server-client-overlay,
  #webpack-hot-middleware-client-overlay {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
`;
document.head.appendChild(hideOverlayCss);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  <AuthProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </AuthProvider>
  
);
//<React.StrictMode>
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
